import {useUserService} from '@/composables/user_service'

export const useTimezoneHelper = () => {
  const setTimeZoneSetting = async (timeZoneUuid: string | null) => {
    const {getTimeZones} = useUserService()
    const timeZones = await getTimeZones()
    return convertTimezoneToSetting(timeZoneUuid, timeZones)
  }

  const splitObject = (settings: any[]) => {
    const timezone = settings.find(el => el.key === 'UserProperty:Timezone')
    const filteredSettings = settings.filter(el => el.key !== 'UserProperty:Timezone')

    return {
      settings: filteredSettings,
      timeZoneUuid: timezone?.value ?? null
    }
  }

  const convertTimezoneToSetting = (timeZoneUuid: string | null, timeZones: any) => {
    const timeZonesArray = timeZones?.value ?? []
    return {
      key: 'UserProperty:Timezone',
      name: 'Timezone',
      settingType: 'ListObjects',
      settingUuid: 'timeZoneOption',
      value: timeZoneUuid,
      settingValueKeys: timeZonesArray.map((t: any) => ({
        value: t.timeZoneUuid,
        key: t.name
      })) ?? []
    }
  }

  return {
    setTimeZoneSetting,
    splitObject,
    convertTimezoneToSetting
  }
}
